import React, { useState, useRef, useEffect } from 'react';
import './AIAgent.css';

const BOT_NAME = 'BricksBot';
const WA_NUMBER = '917477471006';

// Knowledge base — real estate Q&A
const QA = [
  {
    patterns: ['krishna vatika', 'krishna', 'vatika', '4bhk villa'],
    answer: `🏠 *Krishna Vatika* by Paradise Group is a premium 4BHK Villa project located at **Sector 16-B, Greater Noida (West)**.\n\n📐 Sizes: 2100 – 2550 sq.ft\n💰 Starting: ₹57 Lac*\n✅ RERA Approved | Gated Community\n\nWould you like to **book a site visit**?`,
  },
  {
    patterns: ['lotus greens', 'lotus', '3bhk', '116 sq'],
    answer: `🌿 *Lotus Greens Villa 2* offers 3 & 4 BHK Smart Villas at **Vaidpura, Greater Noida West**.\n\n📐 Sizes: 100 – 116 Sq. Yd.\n💰 Starting: ₹65 Lac*\n✅ Vastu Compliant | 25ft Wide Roads | Modular Kitchen\n\nShall I connect you with our team?`,
  },
  {
    patterns: ['srishti', 'aalayam', '2bhk', '72 sq', '91 sq', '100 sq'],
    answer: `🏡 *Aalayam Srishti Villas* by Paradise Group — 2 & 3 BHK Premium Villas at **Greater Noida West – 201009**.\n\n📐 Sizes: 72, 91, 100 Sq. Yd.\n💰 Starting: ₹45 Lac*\n✅ Commercial Club | Parks | CCTV | Power Backup\n\nWant to book a free site visit?`,
  },
  {
    patterns: ['bollywood', 'aero city', 'farm', 'jewar', 'yamuna'],
    answer: `✈️ *Bollywood Aero City Farms* — Luxury Farm Estates near **Jewar International Airport**.\n\n📐 Min. 1000 Sq. Yd. (9000 sq.ft)\n💰 ₹20,000 per Sq. Yd. (All-inclusive)\n📈 200–300% ROI expected by 2030\n🎬 Near YEIDA Film City & F1 Circuit\n\nThis is a rare investment opportunity!`,
  },
  {
    patterns: ['paradise greens', 'green plaza', 'studio', 'retail shop'],
    answer: `🏢 *Paradise Greens Plaza* — Studio Apartments & Retail Shops at **Sector 16B, Noida Extension**.\n\n🏠 Studio: 330–725 sq.ft | ₹23.09 Lac+\n🏪 Retail: 192–365 sq.ft | ₹23.90 Lac+\n📈 Assured Rental @ ₹40/sq.ft Monthly*\n🔑 Ready to Move | Rental from Day 1\n\nFew units left — want to book now?`,
  },
  {
    patterns: ['location', 'greater noida', 'noida west', 'sector 16', 'where'],
    answer: `📍 All our projects are in **Greater Noida West**, one of NCR's fastest-growing corridors:\n\n✈️ 20 min from Jewar Airport\n🛍️ 4 km from Gaur City Mall\n🚇 Upcoming Metro Connectivity\n🏫 SKS, Wisdom Tree, BLS Schools in 1 km\n🏥 Yashoda, Yatharth Hospitals nearby\n🎬 Near YEIDA Film City`,
  },
  {
    patterns: ['price', 'cost', 'rate', 'budget', 'starting', 'kitne'],
    answer: `💰 *Our Property Prices:*\n\n🏠 Krishna Vatika: ₹57 Lac+\n🌿 Lotus Greens Villa 2: ₹65 Lac+\n🏡 Aalayam Srishti: ₹45 Lac+\n✈️ Bollywood Aero Farms: ₹20K/Sq.Yd.\n🏢 Paradise Greens Plaza: ₹23.09 Lac+\n\nAll prices are all-inclusive. Home loan available! 🏦`,
  },
  {
    patterns: ['loan', 'home loan', 'emi', 'finance', 'bank'],
    answer: `🏦 *Home Loan Assistance Available!*\n\nWe have tie-ups with major banks:\n✅ SBI, HDFC, ICICI, Axis Bank\n✅ Low interest rates\n✅ Quick approvals\n✅ Minimal documentation\n✅ EMI starts from ₹18,000/month*\n\nWant us to check your loan eligibility?`,
  },
  {
    patterns: ['rera', 'approved', 'legal', 'registration', 'documents'],
    answer: `✅ *Legal & RERA Details:*\n\nAll our projects are:\n🏛️ RERA Registered & Approved\n📋 Clear Title & Legal Documents\n🔒 Verified by our legal team\n📝 End-to-end registration support\n\nWe handle all paperwork so you don't have to!`,
  },
  {
    patterns: ['amenities', 'facilities', 'features', 'swimming', 'club'],
    answer: `🌟 *Premium Amenities Across Projects:*\n\n🏊 Swimming Pool & Club House\n🌳 Parks & Green Landscaping\n🔒 24/7 Security & CCTV\n⚡ Power Backup\n🚗 Dedicated Parking\n🛕 Temple inside complex\n📞 Intercom facility\n🛣️ Wide Internal Roads\n\nWhich project interests you most?`,
  },
  {
    patterns: ['site visit', 'visit', 'appointment', 'book', 'schedule'],
    answer: `📅 *Book a Free Site Visit!*\n\nOur team will personally guide you through the property.\n\n📞 Call: +91 7477-471-006\n💬 WhatsApp: +91 7477-471-006\n📧 Email: info@bricksnhome.com\n⏰ Mon–Sat: 9 AM – 7 PM\n\nOr scroll down to fill our **Booking Form** 👇`,
  },
  {
    patterns: ['contact', 'phone', 'number', 'call', 'reach', 'email'],
    answer: `📞 *Contact BricksNHome:*\n\n📱 Phone / WhatsApp: **+91 7477-471-006**\n📧 Email: **info@bricksnhome.com**\n📍 Office: Sec 16, Chipyana Bujurg,\n    Greater Noida West – 201009\n⏰ Working Hours: Mon–Sat, 9 AM – 7 PM\n\nWe typically respond within minutes! 🚀`,
  },
  {
    patterns: ['investment', 'roi', 'return', 'appreciate', 'profit'],
    answer: `📈 *Why Invest in Greater Noida West?*\n\n✈️ Jewar Airport — 20 min away (opens 2026)\n🎬 YEIDA Film City — ₹65,000 Cr project\n🏭 Foxconn, Havells, Vivo setting up factories\n📈 25–40% price appreciation already seen\n🎯 Expected 200–300% ROI by 2030\n\nBest time to invest is RIGHT NOW! 💰`,
  },
  {
    patterns: ['hello', 'hi', 'hey', 'hlo', 'namaste', 'namaskar'],
    answer: `👋 *Namaste! Welcome to BricksNHome!*\n\nI'm **BricksBot**, your AI real estate assistant for Greater Noida.\n\nI can help you with:\n🏠 Property details & pricing\n📍 Location advantages\n🏦 Home loan information\n📅 Site visit booking\n💰 Investment opportunities\n\nWhat would you like to know?`,
  },
];

const SUGGESTIONS = [
  '🏠 Krishna Vatika details',
  '✈️ Bollywood Aero Farms',
  '💰 Pricing & Budget',
  '📅 Book Site Visit',
  '📍 Location Info',
  '🏦 Home Loan Help',
];

function getBotReply(input) {
  const lower = input.toLowerCase();
  for (const qa of QA) {
    if (qa.patterns.some(p => lower.includes(p))) {
      return qa.answer;
    }
  }
  return `🤔 I didn't quite catch that. Here's how I can help:\n\n• Ask about any property (Krishna Vatika, Lotus Greens etc.)\n• Get pricing & budget info\n• Book a site visit\n• Learn about Greater Noida location\n\nOr call us directly: **+91 7477-471-006** 📞`;
}

function formatMessage(text) {
  return text
    .replace(/\*([^*]+)\*/g, '<strong>$1</strong>')
    .replace(/\n/g, '<br/>');
}

export default function AIAgent() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    {
      id: 1, from: 'bot',
      text: `👋 Namaste! I'm **BricksBot** — your AI assistant for Greater Noida real estate.\n\nAsk me anything about properties, pricing, location, or investment! 🏠`,
      time: new Date(),
    },
  ]);
  const [input, setInput] = useState('');
  const [typing, setTyping] = useState(false);
  const bottomRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, typing]);

  useEffect(() => {
    if (open) setTimeout(() => inputRef.current?.focus(), 300);
  }, [open]);

  const sendMessage = (text) => {
    const userText = text || input.trim();
    if (!userText) return;
    setInput('');

    const userMsg = { id: Date.now(), from: 'user', text: userText, time: new Date() };
    setMessages(prev => [...prev, userMsg]);
    setTyping(true);

    setTimeout(() => {
      const reply = getBotReply(userText);
      setTyping(false);
      setMessages(prev => [...prev, { id: Date.now() + 1, from: 'bot', text: reply, time: new Date() }]);
    }, 900 + Math.random() * 600);
  };

  const handleKey = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
  };

  const timeStr = (d) => d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  return (
    <>
      {/* ── CHAT WINDOW ── */}
      {open && (
        <div className="ai-chat-window">
          {/* Header */}
          <div className="ai-header">
            <div className="ai-header-left">
              <div className="ai-avatar">
                <i className="fa fa-robot" />
                <span className="ai-online-dot" />
              </div>
              <div>
                <div className="ai-name">{BOT_NAME}</div>
                <div className="ai-status">
                  <span className="ai-status-dot" /> Online · BricksNHome
                </div>
              </div>
            </div>
            <div className="ai-header-actions">
              <a
                href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent('Hi! I need help with a property in Greater Noida.')}`}
                target="_blank" rel="noreferrer"
                className="ai-wa-btn" title="Continue on WhatsApp"
              >
                <i className="fab fa-whatsapp" />
              </a>
              <button className="ai-close-btn" onClick={() => setOpen(false)}>
                <i className="fa fa-times" />
              </button>
            </div>
          </div>

          {/* Messages */}
          <div className="ai-messages">
            {messages.map(msg => (
              <div key={msg.id} className={`ai-msg-wrap ${msg.from}`}>
                {msg.from === 'bot' && (
                  <div className="ai-msg-avatar"><i className="fa fa-robot" /></div>
                )}
                <div className="ai-msg-bubble">
                  <div
                    className="ai-msg-text"
                    dangerouslySetInnerHTML={{ __html: formatMessage(msg.text) }}
                  />
                  <div className="ai-msg-time">{timeStr(msg.time)}</div>
                </div>
              </div>
            ))}

            {typing && (
              <div className="ai-msg-wrap bot">
                <div className="ai-msg-avatar"><i className="fa fa-robot" /></div>
                <div className="ai-msg-bubble">
                  <div className="ai-typing">
                    <span /><span /><span />
                  </div>
                </div>
              </div>
            )}
            <div ref={bottomRef} />
          </div>

          {/* Quick Suggestions */}
          <div className="ai-suggestions">
            {SUGGESTIONS.map((s, i) => (
              <button key={i} className="ai-suggestion" onClick={() => sendMessage(s)}>
                {s}
              </button>
            ))}
          </div>

          {/* Input */}
          <div className="ai-input-area">
            <input
              ref={inputRef}
              type="text"
              placeholder="Ask about properties, price, location..."
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={handleKey}
            />
            <button
              className="ai-send-btn"
              onClick={() => sendMessage()}
              disabled={!input.trim()}
            >
              <i className="fa fa-paper-plane" />
            </button>
          </div>

          <div className="ai-footer-note">
            <i className="fa fa-shield-halved" /> Powered by BricksNHome AI ·
            <a href={`https://wa.me/${WA_NUMBER}`} target="_blank" rel="noreferrer">
              &nbsp;<i className="fab fa-whatsapp" /> Chat with a human
            </a>
          </div>
        </div>
      )}

      {/* ── TOGGLE BUTTON ── */}
      <button
        className={`ai-toggle-btn ${open ? 'open' : ''}`}
        onClick={() => setOpen(!open)}
        aria-label="AI Chat Assistant"
      >
        {open ? (
          <i className="fa fa-times" />
        ) : (
          <>
            <i className="fa fa-robot" />
            <span className="ai-toggle-badge">AI</span>
          </>
        )}
        {!open && <span className="ai-toggle-pulse" />}
      </button>
    </>
  );
}
